<template>
    <span>{{date}}</span>
</template>

<script>

    import * as moment from 'moment';

    export default {
        name: 'CellRendererAvatar',
        computed: {
            date () {
                return new moment(this.params.value).format('Do MMMM YYYY h:mm:ss A');
            }
        }
    }
</script>
